import { Spinner } from "./ui/Spinner";

interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-12">
      <Spinner size={32} />
      {label && <p className="text-sm text-text-secondary">{label}</p>}
    </div>
  );
}
